import BackspaceOutlinedIcon from '@mui/icons-material/BackspaceOutlined';
import KeyboardTabOutlinedIcon from '@mui/icons-material/KeyboardTabOutlined';
import React, { useEffect, useState } from 'react';
import { ButtonsWrapper, KeyBoardButton, KeyButton, Message, Pad, PinDisplay } from './styles';

export interface IPinPad {
    handleEnter: (pin: string) => void;
    message?: string;
    valid: boolean;
}

const PinPad: React.FC<IPinPad> = ({ handleEnter, message, valid }) => {
    const pinPlaceHolder = '----';
    const [pin, setPin] = useState(pinPlaceHolder);

    const handleKeyClick = (val: number) => {
        const cleanPin = pin.replace(pinPlaceHolder, '');
        if (cleanPin.length >= 4) return;
        setPin(`${cleanPin}${val}`);
    };

    const handleBackspaceClick = () => {
        setPin(pin => pin.slice(0, pin.length - 1));
    };

    const handleSavePinClick = () => {
        setPin(pinPlaceHolder);
        handleEnter(pin.replace(pinPlaceHolder, ''));
    };

    useEffect(() => {
        const handleKeyPress = (event: KeyboardEvent) => {
            const cleanPin = pin.replace(pinPlaceHolder, '');
            const val = event.code.replace('Numpad', '').replace('Digit', '');
            const keyList = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

            if (keyList.includes(val) && cleanPin.length < 4) {
                setPin(`${cleanPin}${val}`);
            }

            if (val === 'Backspace') handleBackspaceClick();
            if (val === 'Enter') handleSavePinClick();
        };

        if (!pin) return;

        document.addEventListener('keydown', handleKeyPress);
        return () => document.removeEventListener('keydown', handleKeyPress);
    }, [pin]);

    return (
        <Pad>
            <Message invalidPin={!valid}>{message}</Message>
            <PinDisplay>{pin}</PinDisplay>
            <ButtonsWrapper>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(n => (
                    <KeyButton key={n} onClick={() => handleKeyClick(n)}>
                        {n}
                    </KeyButton>
                ))}
                <KeyBoardButton aria-label='backspace' onClick={handleBackspaceClick}>
                    <BackspaceOutlinedIcon />
                </KeyBoardButton>
                <KeyButton onClick={() => handleKeyClick(0)}>0</KeyButton>
                <KeyBoardButton aria-label='save' onClick={handleSavePinClick}>
                    <KeyboardTabOutlinedIcon />
                </KeyBoardButton>
            </ButtonsWrapper>
        </Pad>
    );
};

export default PinPad;
